import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IPayment } from '@core/interfaces/payment/payment.interface';
import { OnlinePaymentMethod } from '@interticket/core';

export const PAYMENT_METHOD_LIST: IListResult<IPayment> = {
  results: [
    {
      id: '941fef20-0cf9-4e23-b524-82a502f5ab6b',
      displayName: 'stemx_pay_free',
      type: {
        name: OnlinePaymentMethod.FREE,
        label: 'free_payment_method_type',
      },
    },
    {
      id: '55838f25-876d-4e7e-9b69-31149e08ac75',
      displayName: 'stemx_pay_quickpay',
      type: {
        name: OnlinePaymentMethod.QUICKPAY,
        label: 'quickpay_payment_method_type',
      },
    },
    {
      id: 'd75c3464-3ee8-45d0-bb9f-a4f46fa6a73e',
      displayName: 'stemx_pay_payu',
      type: {
        name: OnlinePaymentMethod.PAYU,
        label: 'payu_payment_method_type',
      },
    },
    {
      id: '835ae8b5-3393-467b-82b3-6a5c30a90a99',
      displayName: 'stemx_pay_otpsimple',
      type: {
        name: OnlinePaymentMethod.OTP_SIMPLE,
        label: 'otpsimple_payment_method_type',
      },
    },
    {
      id: 'f1a59019-6ef1-4acc-b373-c6f423efbe9b',
      displayName: 'stemx_pay_stripe',
      type: {
        name: OnlinePaymentMethod.STRIPE,
        label: 'stripe_payment_method_type',
      },
    },
    {
      id: '322becf5-aec1-4172-addc-bd1a939d3c23',
      displayName: 'stemx_pay_cib',
      type: {
        name: OnlinePaymentMethod.CIB,
        label: 'cib_payment_method_type',
      },
    },
  ],
  resultsLength: 6,
};
